import script from "./LimitStocksView.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitStocksView.vue?vue&type=script&setup=true&lang=js"

import "./LimitStocksView.vue?vue&type=style&index=0&id=a24d0ce8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a24d0ce8"]])

export default __exports__